module.exports = __webpack_public_path__ + "img/intro-seguridad.d3a31df5.png";